// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2u8wD","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Sk02"};